import * as types from './actionTypes';
// ---- local imports ----

export function characterLoaded(character) {
	return { type: types.CHARACTER_LOADED, character: character.toPlainObj() };
}

export function characterSelected(character) {
	return { type: types.CHARACTER_SELECTED, character: character.toPlainObj() };
}
